import { reactive } from "vue";
const state = reactive({
    textShort: (text, maxLength) => {
        if (!text || typeof text !== 'string') {
            return '';
        }
        if (text.length > maxLength) {
            return text.substring(0, maxLength) + '...';
        }
        return text;
    },
    currentYear: () =>{
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        return currentYear;
    },
    formatDate:(dateString) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
        const year = date.getFullYear();
        const hours = date.getHours() % 12 || 12; // Convert to 12-hour format
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const amPm = date.getHours() >= 12 ? 'PM' : 'AM'; // Determine AM or PM
        const time = `${hours}:${minutes} ${amPm}`;
        return `${day}-${month}-${year} ${time}`;
    },
    invFormatDate:(dateString) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
        const year = date.getFullYear();
        const hours = date.getHours() % 12 || 12; // Convert to 12-hour format
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const amPm = date.getHours() >= 12 ? 'PM' : 'AM'; // Determine AM or PM
        const time = `${hours}:${minutes} ${amPm}`;
        return `${day}-${month}-${year}`;
    },
    locale: 'EN',
    isLoading:true
});

const helperStore = () => {
    return state
}

export { helperStore }
